import React, { useState, useEffect } from 'react'
import { Button, Row, Col, TimePicker, Checkbox } from 'antd'
import Modal from 'antd/lib/modal/Modal'
import { DeleteOutlined, PlusCircleOutlined } from '@ant-design/icons'
import moment, { Moment } from 'moment'
import Calendar from 'react-calendar'
import {
  convertMinutesToLocalTime,
  convertTimeToUtcMinutes,
} from 'helper/utility'
import { SpecialSchedule } from 'types/globalTypes'
import { infoMessage } from 'api/global'
import { Copy } from '@phosphor-icons/react'

const AddSpecialScheduleModal = ({
  addSpecialScheduleModalVisible,
  setAddSpecialScheduleModalVisible,
  specialScheduleData,
  setSpecialScheduleData,
  selectedDates,
}: any) => {
  const [specialScheduleInputData, setSpecialScheduleInputData] = useState([])
  const [copyModalVisible, setCopyModalVisible] = useState(false)
  const [copySource, setCopySource] = useState<SpecialSchedule | null>(null)
  const [selectedCopyDays, setSelectedCopyDays] = useState<string[]>([])

  useEffect(() => {
    setSpecialScheduleInputData([...specialScheduleData])
    console.log(specialScheduleData)
  }, [specialScheduleData])

  const [selectedDate, setSelectedDate] = useState<any>('')

  const handleTileClick = (date: any) => {
    const formattedDate = moment(date).format('YYYY-MM-DD')
    setSelectedDate(formattedDate)
  }

  const tileDisabled = ({ date }: { date: Date }) =>
    !selectedDates.find((d: string) => d === moment(date).format('YYYY-MM-DD'))

  const DEFAULT_START = 240
  const DEFAULT_END = 600
  const weekDays = [
    'Sunday',
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday',
  ]

  const getWeekDay = (date: string) => moment(date).format('dddd')

  const addSpecialscheduleInput = (date: String) => {
    // @ts-ignore
    setSpecialScheduleInputData([
      ...specialScheduleInputData,
      {
        day: date,
        startTime: DEFAULT_START,
        endTime: DEFAULT_END,
      },
    ])
  }

  const handleStartTimeChange = (
    day: string,
    _time: Moment | null,
    timeString: string,
  ) => {
    setSpecialScheduleInputData((prev: any) =>
      prev.map((item: any) =>
        item.day === day
          ? { ...item, startTime: convertTimeToUtcMinutes(timeString) }
          : item,
      ),
    )
  }
  const handleEndTimeChange = (
    day: string,
    _time: Moment | null,
    timeString: string,
  ) => {
    setSpecialScheduleInputData((prev: any) =>
      prev.map((item: any) =>
        item.day === day
          ? { ...item, endTime: convertTimeToUtcMinutes(timeString) }
          : item,
      ),
    )
  }

  const removeSpecialscheduleInput = (index: number) => {
    const current: any = specialScheduleInputData[index]
    setSpecialScheduleInputData([
      ...specialScheduleInputData.filter(
        (data: any) => data.day !== current.day,
      ),
    ])
  }

  const timeFormat = 'HH:mm a'

  const openCopyModal = (schedule: SpecialSchedule) => {
    setCopySource(schedule)
    setSelectedCopyDays([])
    setCopyModalVisible(true)
  }

  const copyToWeekDay = (weekday: string) => {
    if (!copySource) return
    const copyStart =
      copySource.startTime !== undefined ? copySource.startTime : DEFAULT_START
    const copyEnd =
      copySource.endTime !== undefined ? copySource.endTime : DEFAULT_END

    setSpecialScheduleInputData((prev: any) => {
      const map = new Map<string, any>()
      prev.forEach((item: any) => map.set(item.day, { ...item }))

      selectedDates.forEach((date: string) => {
        if (getWeekDay(date) === weekday) {
          const existing = map.get(date)
          if (existing) {
            map.set(date, {
              ...existing,
              startTime: copyStart,
              endTime: copyEnd,
            })
          } else {
            map.set(date, { day: date, startTime: copyStart, endTime: copyEnd })
          }
        }
      })

      return Array.from(map.values())
    })
  }

  const handleCopyCheckboxChange = (weekday: string, checked: boolean) => {
    setSelectedCopyDays(prev =>
      checked ? [...prev, weekday] : prev.filter(d => d !== weekday),
    )
    if (checked) {
      copyToWeekDay(weekday)
    }
  }

  return (
    <div>
      <Modal
        title="Add Special Schedule"
        open={addSpecialScheduleModalVisible}
        className="map-modal"
        footer={null}
        centered={true}
        width={450}
        onCancel={() => {
          setAddSpecialScheduleModalVisible(false)
        }}
      >
        <Col>
          <div>
            <div className="h-27rem overflow-auto-y scroller pb-20px">
              <Row className="mt-20">
                <div style={{ marginBottom: 20 }}>
                  <Calendar
                    calendarType="US"
                    onClickDay={handleTileClick}
                    tileDisabled={tileDisabled}
                    tileClassName={({ date, view }) => {
                      if (selectedDate === moment(date).format('YYYY-MM-DD')) {
                        return 'selected'
                      }
                    }}
                  />
                </div>
                <Col span={24}>
                  <span style={{ marginBottom: 10 }}>
                    <b>Special schedule</b>
                  </span>
                  <PlusCircleOutlined
                    onClick={() => {
                      if (selectedDate) {
                        console.log(specialScheduleInputData)
                        if (
                          specialScheduleInputData.find(
                            (d: any) => d.day === selectedDate,
                          )
                        ) {
                          infoMessage(
                            'Already added special schedule for this date',
                          )
                        } else {
                          addSpecialscheduleInput(selectedDate)
                        }
                      }
                    }}
                  />
                </Col>
                <Col span={24}>
                  {specialScheduleInputData.map((s: SpecialSchedule, index) => {
                    return (
                      <Row className="d-flex justify-between align-items-center mb-10 w-full">
                        <Col span={24}>
                          <span style={{ marginBottom: 10 }}>
                            <b>{s?.day}</b>
                          </span>
                        </Col>
                        <div className="flex justify-between align-center w-full">
                          <div className="flex align-center gap-16px mt-15px">
                            <TimePicker
                              className="w-100 form-control-field"
                              placeholder="Start Time"
                              format="h:mm a"
                              showNow={false}
                              clearIcon={false}
                              defaultValue={moment(
                                convertMinutesToLocalTime(s.startTime || 240),
                                'hh:mm A',
                              )}
                              onChange={(time, timeString) =>
                                handleStartTimeChange(s.day, time, timeString)
                              }
                            />
                            <div>-</div>
                            <TimePicker
                              className="w-100 form-control-field"
                              placeholder="End Time"
                              format="h:mm a"
                              showNow={false}
                              clearIcon={false}
                              defaultValue={moment(
                                convertMinutesToLocalTime(s.endTime || 600),
                                'hh:mm A',
                              )}
                              onChange={(time, timeString) =>
                                handleEndTimeChange(s.day, time, timeString)
                              }
                            />
                          </div>

                          <div className="flex align-center gap-8px">
                            <Copy
                              className="pointer"
                              size={20}
                              onClick={() => openCopyModal(s)}
                            />
                            <DeleteOutlined
                              onClick={() => removeSpecialscheduleInput(index)}
                              style={{
                                color: '#FF6961',
                                paddingLeft: '5px',
                              }}
                            />
                          </div>
                        </div>
                      </Row>
                    )
                  })}
                </Col>
              </Row>
            </div>
            <Row>
              <Col className="d-flex">
                <Button
                  className="route_button-events br-8"
                  onClick={() => setAddSpecialScheduleModalVisible(false)}
                >
                  Cancel
                </Button>
                <Button
                  className="venue_button-events br-8"
                  onClick={() => {
                    setSpecialScheduleData([
                      ...specialScheduleInputData.map((data: any) => ({
                        ...data,
                        startTime:
                          data.startTime !== undefined
                            ? data.startTime
                            : DEFAULT_START,
                        endTime:
                          data.endTime !== undefined
                            ? data.endTime
                            : DEFAULT_END,
                      })),
                    ])
                    setAddSpecialScheduleModalVisible(false)
                  }}
                >
                  Apply
                </Button>
              </Col>
            </Row>
          </div>
        </Col>
      </Modal>
      <Modal
        title="Copy schedule to days"
        open={copyModalVisible}
        centered={true}
        onCancel={() => setCopyModalVisible(false)}
        footer={
          <Button type="primary" onClick={() => setCopyModalVisible(false)}>
            Done
          </Button>
        }
      >
        <div className="flex flex-column gap-10px">
          {weekDays.map(day => (
            <Checkbox
              key={day}
              checked={selectedCopyDays.includes(day)}
              onChange={e => handleCopyCheckboxChange(day, e.target.checked)}
            >
              {day}
            </Checkbox>
          ))}
        </div>
      </Modal>
    </div>
  )
}

export default AddSpecialScheduleModal
